class Semaphore {
    _permits;
    _queue = [];
    
    constructor(initPermits) {
        if (!initPermits) {
            initPermits = 0;
        }
        this._permits = initPermits;
    }
    
    release(permits) {
        if (!permits) {
            permits = 1;
        }
        // 释放
        this._permits += permits;
        
        // 有等待中的，触发执行
        if (this._queue.length == 0) {
            return;
        }
        let promise = this._queue.shift();
        let acquirePermits = promise.permits;
        if (this._permits < acquirePermits) {
            this._queue.unshift(promise);
            return;
        }
        this._permits -= acquirePermits;
        promise.resolve();
    }
    
    acquire(permits) {
        if (!permits) {
            permits = 1;
        }
        if (this._permits >= permits) {
            this._permits -= permits;
            return;
        }

        return new Promise(resolve => {
            this._queue.push({
                permits, 
                resolve
            });
        });
    }
}

export default Semaphore;